module.exports = __webpack_public_path__ + "src/assets/img/Stellum.dbc27bd5.png";